/**
 * Populate sidebar with product posts from the selected category.
 */

const listPostsPost = async (post) => {
	const productGridEnd = document.querySelector('.product-grid-end');
	const pBtn = document.createElement('button');
	const pImg = new Image(150, 150);
	const pPara = document.createElement('p');

	pImg.setAttribute('src', post.featured_thumb_url);
	pImg.className = 'product-sidebar__image';
	pBtn.setAttribute('data-product-id', post.id);
	pBtn.className = 'product-sidebar__item u-1of2 u-p0 u-mt-half u-mb-half u-mx0';
	pPara.className = 'product-title u-titlecase has-small-font-size u-mt-half u-mb0';

	pPara.textContent = post.title.rendered;
	pBtn.append(pImg, pPara);
	productGridEnd.before(pBtn);

	if (!post.dc_table_image_url) {
		pBtn.classList.add('no-image');
	}

	if (!pImg.src) {
		pImg.setAttribute('src', post.dc_table_image_url);
	}
};

export default listPostsPost;
